import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVCheck } from "../../shared/JVCheck";
import { IClientTnfr } from "../clientTransfer/ClientTnfr";
import { Dialog } from "primereact/dialog";
import { IUsersDropdown } from "../../models/IDropdown";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { JVDropdown } from "../../shared/JVDropdown";
import { ILogin } from "../../models/Login";

interface Iprops {
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    open: boolean,
    hideDialog: () => void,
    salesPerson_Company_ID?: number
}

const schema = yup.object({
    salesPersonTo: yup.number().required("Select Sales Manager").min(1, "Select Sales Manager")
});

export const MultipleTransferSales = (props: Iprops) => {
    const [loading, setLoading] = useState(false);
    const [sales, setSales] = useState<Array<IUsersDropdown>>();
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IClientTnfr>, loading: boolean });
    const [selectedClients, setSelectedClients] = useState<Array<number>>([]);
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');

    const { control, handleSubmit, formState: { errors }, reset } = useForm<{ salesPersonTo: number }>({
        resolver: yupResolver(schema),
        defaultValues: { salesPersonTo: 0 },
        shouldFocusError: false
    });

    useEffect(() => {
        if (props.open) {
            loadSales();
            loadTableData(loginObj.id);
        }
    }, [props.open]);

    const loadTableData = async (salesPerson: number) => {
        setTableData({ tableData: [], loading: true });
        const response = await Fetch("Sub_Vendor_Contact_Person_Mast/sm", "GET", null, `salesPerson=${salesPerson}`, props.toast);
        if (response) {
            const data: any = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: [], loading: false });
    }

    const loadSales = async () => {
        const response = await Fetch("Dropdown/Userslist", "GET", null, `company_id=${0}&role_id=${2}`, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            setSales(data);
        }
    }

    const selectHead = () => {
        return (
            <span onClick={() => {
                if (tableData.tableData.length === selectedClients.length) {
                    setSelectedClients([]);
                } else {
                    const temp: Array<number> = [];
                    tableData.tableData.forEach((data) => {
                        if (data.contact_Person_Id) temp.push(data.contact_Person_Id)
                    });
                    setSelectedClients(temp);
                }
            }}>
                <JVCheck name="select_all_clients" defaultValue={tableData.tableData.length > 0 && tableData.tableData.length === selectedClients.length}></JVCheck>
            </span>
        );
    }
    const onSelect = (rowData: IClientTnfr) => {
        if (rowData.contact_Person_Id) {
            if (selectedClients.includes(rowData.contact_Person_Id)) {
                const temp = selectedClients.filter((t) => { return t !== rowData.contact_Person_Id });
                setSelectedClients(temp);
            } else {
                const temp = [...selectedClients];
                temp.push(rowData.contact_Person_Id);
                setSelectedClients(temp);
            }
        }
    }

    const select = (rowData: IClientTnfr) => {
        return (<span onClick={() => onSelect(rowData)}>
            <JVCheck name={rowData.contact_Person_EmailID} defaultValue={rowData.contact_Person_Id !== undefined && selectedClients.includes(rowData.contact_Person_Id)}></JVCheck>
        </span>
        );
    }

    const transferClients = async (data: { salesPersonTo: number }) => {
        setLoading(true);
        const contact: Array<{ contactPersonID?: number }> = [];
        selectedClients.forEach(client => {
            contact.push({ contactPersonID: client });
        });
        const response = await Fetch("Sub_Vendor_Contact_Person_Mast/mutualClients", "POST", null, `salesManagerFrom=${loginObj.id}&salesManagerTo=${data.salesPersonTo}&contactPersons=${JSON.stringify(contact)}`, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', content: "Client Transfered Successfully." });
            onHide();
            props.setReload(!props.reload);
        }
        setLoading(false);
    }

    function onSubmit(data: { salesPersonTo: number }) {
        if (selectedClients.length > 0) transferClients(data);
        else props.toast.current.show({ severity: 'error', detail: "Select Client Contact Person to Transfer.", life: 3000 });
    }
    const onHide = () => {
        props.hideDialog();
        reset();
        setSelectedClients([]);
        setTableData({ tableData: [], loading: false });
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Transfer Multiple Client Contact Persons" className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mb-3">
                <JVDropdown column={2} label="Sales Manager" control={control} name="salesPersonTo" options={sales} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Sales Manager" error={errors.salesPersonTo?.message} />
                <div className="field col-12 md:col-6">
                    <label htmlFor="">&nbsp;</label>
                    <Button loading={loading} label="TRANSFER" type="submit"></Button>
                </div>
            </form>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.5)', borderTopWidth: "0" }}
                size="small" value={tableData.tableData} loading={tableData.loading} showGridlines
            >
                <Column field="select" header={selectHead} body={select} />
                <Column field="contact_Person_Name" header="Contact Person" style={{ minWidth: '12rem' }} sortable />
                <Column field="vendor_Company_Name" header="Company Name" style={{ minWidth: '14rem' }} sortable />
                <Column field="city_Name" header="City" style={{ minWidth: '8rem' }} />
                <Column field="state_Name" header="State" style={{ minWidth: '2rem' }} />
                <Column field="salesPerson" header="Sales Person" style={{ minWidth: '10rem' }} sortable />
            </DataTable>
        </Dialog>
    );
}
